import { LinkButton, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './EmptyChatList.css';

import archiveImg from './assets/archive@2x.png';

import spamImg from './assets/blocked@2x.png';

import messagesImg from './assets/nomessages@2x.png';

import starredImg from './assets/starred.png';

import unreadImg from './assets/unread@2x.png';
import { EDeviceType } from '../../types/deviceType';
import { ERoute, TRoute } from '../../types/route';

type TEmptyChatListProps = {
  route: TRoute;
  withLinkButton?: boolean;
};

const Images: { [key in ERoute]: string } = {
  [ERoute.Archive]: archiveImg,
  [ERoute.Messages]: messagesImg,
  [ERoute.Spam]: spamImg,
  [ERoute.Unread]: unreadImg,
  [ERoute.Starred]: starredImg,
};

const HeadingTexts: { [key in ERoute]: string | React.ReactNode } = {
  [ERoute.Archive]: (
    <>
      Здесь будут
      <br />
      архивные чаты
    </>
  ),
  [ERoute.Messages]: 'Здесь пока нет сообщений',
  [ERoute.Spam]: (
    <>
      Здесь будут
      <br />
      заблокированные чаты
    </>
  ),
  [ERoute.Unread]: (
    <>
      Здесь будут
      <br />
      непрочитанные сообщения
    </>
  ),
  [ERoute.Starred]: (
    <>
      У вас пока нет
      <br />
      важных чатов
    </>
  ),
};

const DescriptionTexts: { [key in ERoute]: string | React.ReactNode } = {
  [ERoute.Archive]: 'Таких пока нет',
  [ERoute.Messages]: (
    <>
      Они появятся, как только
      <br />
      кто-нибудь напишет
    </>
  ),
  [ERoute.Spam]: 'Таких пока нет',
  [ERoute.Unread]: 'Таких пока нет',
  [ERoute.Starred]: (
    <>
      Отметьте важные чаты —
      <br />
      они появятся здесь
    </>
  ),
};

export const EmptyChatList: React.FC<TEmptyChatListProps> = ({ route, withLinkButton = true }) => {
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;
  const showLinkButton = !isMobile && route === ERoute.Messages && withLinkButton;

  return (
    <div className={styles['container']}>
      <div className={styles['image']}>
        <img
          src={Images[route]}
          width={route === ERoute.Starred ? 135 : 200}
          height={route === ERoute.Starred ? 165 : 200}
          alt="Тип сообщений"
        />
      </div>
      <div className={styles['heading']}>
        <UIHeading2 color="text-primary-default" data-testid="EmptyChatListTitle">
          {HeadingTexts[route]}
        </UIHeading2>
        <UIText1 color="text-secondary-default">{DescriptionTexts[route]}</UIText1>
      </div>
      {showLinkButton && (
        <span className={styles['button']}>
          <LinkButton theme="fill_primary" href="/">
            Искать недвижимость
          </LinkButton>
        </span>
      )}
    </div>
  );
};
